import moment from 'moment'

/**
 * @param {date|moment} start The start date
 * @param {date|moment} end The end date
 * @param {string} type The range type. eg: 'days', 'hours' etc
 */
export function getRange(startDate : string | Date, endDate : string | Date, type : moment.unitOfTime.Diff) {
  let fromDate = moment(startDate)
  let toDate = moment(endDate)
  let diff = toDate.diff(fromDate, type)
  let range = []
  for (let i = 0; i <= diff; i++) {
    range.push(moment(startDate).add(i, type))
  }
  return range
}

export const addDays = (start: Date, days:number) => {
    var date = new Date(start.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

export const getPreviousMonday = () =>
{
    var date = new Date();
    var day = date.getDay();
    var prevMonday = new Date();
    prevMonday.setDate(date.getDate() - day - 7);

    return prevMonday;
}

export const addMinutes = (date : Date | undefined, minutes : number) => {
    return date ? new Date(date.getTime() + minutes*60000) : new Date(new Date().getTime() + minutes*60000);
}
